import { NgModule, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Autocomplete } from './autocomplete.component';
import { FormsModule, ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { ComponentesService } from '../componentes.service';
import { TableOptionsComponent } from './table-options/table-options.component';

@NgModule({
	declarations: [
		Autocomplete,
		TableOptionsComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatAutocompleteModule,
		MatFormFieldModule,
		MatIconModule,
		MatButtonModule,
		MatInputModule,
		MatChipsModule,
		MatTableModule
	],
	exports: [
		Autocomplete
	],
	providers: [
		ComponentesService
	]
})
export class AutocompleteModule { }
